import BaseStore from 'fluxible/addons/BaseStore';

export default class UserStore extends BaseStore {
    static storeName = 'UserStore';

    static handlers: { [key: string]: keyof UserStore } = {
        LOAD_USER_DATA: 'load',
    };

    loggedIn = false;
    language: string = '';
    country: string = '';
    isGDPRApplicable = false;
    locale: string = '';

    load(data: { isLoggedIn: boolean; locale: string; isGDPRApplicable: boolean }) {
        this.loggedIn = data.isLoggedIn;

        const [language, country] = data.locale.split('-');
        this.country = country;
        this.language = language;
        this.isGDPRApplicable = data.isGDPRApplicable;
        this.locale = data.locale;

        this.emitChange();
    }

    /**
     * Is a user required to give consent before we send them marketing material.
     */
    isEmailMarketingConsentRequired() {
        return this.isGDPRApplicable;
    }

    isLoggedIn() {
        return this.loggedIn;
    }

    getLanguage() {
        return this.language;
    }

    getLocale() {
        return this.locale;
    }
}
